import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { UpdateNotificationComponent } from '../../modals/update-notification/update-notification.component';
import { DashboardServiceService } from '../../services/dashboard-service.service';
import { PaymentComponent } from 'src/app/modules/shared/components/payment/payment.component';
import { AuthService } from 'src/app/services/auth.service';
import { GlobalService } from 'src/app/services/global.service';
import * as CryptoJS from 'crypto-js';
import { NumberModalComponent } from '../../modals/number-modal/number-modal.component';
import { BlankNameComponent } from '../../modals/blank-name/blank-name.component';
import { BlankEmailComponent } from '../../modals/blank-email/blank-email.component';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  @ViewChild(PaymentComponent, { static: false })
  private paymentComponent!: PaymentComponent;

  isEdit: boolean;
  isEditPassword: boolean;
  isEditPayment: boolean;
  isLoaded: boolean;

  profileInfo: any;
  paymentInfo: any;
  profileForm: any;
  passwordForm: any;
  paymentForm: any;
  dummyPass: any;
  selectedIndustry: any;
  industry: any[];
  passwordMatch: any = true;
  oldPasswordMatch: any = true;

  userEn = 'userEncrpto';

  constructor(
    private dialog: MatDialog,
    public dashboardService: DashboardServiceService,
    public auth: AuthService,
    public global: GlobalService,
    private MapService: MapServiceService
  ) {
    this.isEdit = false;
    this.isLoaded = false;
    this.isEditPassword = false;
    this.isEditPayment = false;
    //getting list of industries from service
    this.industry = this.dashboardService.getIndustryList();
  }

  ngOnInit(): void {
    //dynamic modal handling
    this.MapService.dynamicModalCheck(
      '',
      this.MapService.isLiveShareLink,
      true,
      false
    );

    //password form group
    this.passwordForm = new FormGroup({
      current_password: new FormControl('', Validators.required),
      new_password: new FormControl('', Validators.required),
      new_password_2: new FormControl('', Validators.required),
    });

    //payment form group
    this.paymentForm = new FormGroup({
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      cardNumber: new FormControl(''),
    });

    if (this.dashboardService.mapsAndProfile != null) {
      this.updateData();
    }

    this.dashboardService.dataLoaded.subscribe(() => {
      this.updateData();
    });
  }

  updateData(): void {
    this.profileInfo = this.dashboardService.mapsAndProfile.profile_payment;
    this.paymentInfo = this.dashboardService.mapsAndProfile.profile_payment;
    this.isLoaded = true;
    //show current data to profile tab
    if (this.profileInfo) {
      this.profileForm = new FormGroup({
        first_name: new FormControl(this.profileInfo.profile.first_name),
        last_name: new FormControl(this.profileInfo.profile.last_name),
        email: new FormControl(this.profileInfo.profile.user_email),
        phone_number: new FormControl(this.profileInfo.profile.user_phone),
        organization: new FormControl(this.profileInfo.profile.organization),
        industry: new FormControl(this.profileInfo.profile.industry),
      });
    }
    this.selectedIndustry = this.profileInfo.profile.industry;
  }

  editProfile(e: Event): void {
    e.preventDefault();
    this.isEdit = true;
  }

  back(): void {
    this.isEdit = false;
    this.isEditPassword = false;
    this.passwordMatch = true;
    this.oldPasswordMatch = true;
    this.ngOnInit();
  }

  editPassword(): void {
    this.isEdit = true;
    this.isEditPassword = true;
  }

  //check if user enter valid number
  isNumber(n: any) {
    return /^(\d+-?)+\d+$/.test(n);
  }

  //check if user enter  valid email
  validateEmail(email: any) {
    // eslint-disable-next-line no-useless-escape
    const regularExpression = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return regularExpression.test(String(email).toLowerCase());
  }

  //for updating profile with relevant checks
  submitProfile(): void {
    //setting empty string values if form value is null
    if (this.profileForm.value.organization == null) {
      this.profileForm.value.organization = ' ';
    }
    if (this.profileForm.value.industry == null) {
      this.profileForm.value.industry = ' ';
    }
    if (this.profileForm.value.phone_number == null) {
      this.profileForm.value.phone_number = ' ';
    }

    //numbers allowed only modal
    if (
      !this.isNumber(this.profileForm.value.phone_number) &&
      this.profileForm.value.phone_number !== ' ' &&
      this.profileForm.value.phone_number !== ''
    ) {
      this.dialog.open(NumberModalComponent, {
        position: {
          top: '10%',
          left: '36.8%',
        },
        backdropClass: 'bdrop',
      });
    } else if (
      this.profileForm.value.first_name == null ||
      this.profileForm.value.first_name == ''
    ) {
      //blank first name modal
      this.dialog.open(BlankNameComponent, {
        data: {
          message: 'First name blank.',
        },
        position: {
          top: '10%',
          left: '40.9%',
        },
        panelClass: 'app-full-bleed-dialog',
        backdropClass: 'bdrop',
      });
    } else if (
      this.profileForm.value.last_name == null ||
      this.profileForm.value.last_name == ''
    ) {
      //blank last name modal
      this.dialog.open(BlankNameComponent, {
        data: {
          message: 'Last name blank.',
        },
        panelClass: 'app-full-bleed-dialog',
        backdropClass: 'bdrop',
        position: {
          top: '10%',
          left: '40.9%',
        },
      });
    } else if (
      this.profileForm.value.email == null ||
      this.profileForm.value.email == '' ||
      !this.validateEmail(this.profileForm.value.email)
    ) {
      //invalid or empty email modal
      this.dialog.open(BlankEmailComponent, {
        panelClass: 'app-full-bleed-dialog',
        backdropClass: 'bdrop',

        position: {
          top: '10%',
          left: '29.6%',
        },
      });
    } else {
      this.global.toggleLoader(true);
      if (this.dashboardService.subscription) {
        this.dashboardService.subscription.unsubscribe();
      }
      this.dashboardService.subscription = this.dashboardService
        .updateProfile(this.profileForm.value)
        .subscribe(
          (res) => {
            if (res.status == 'true' || res.status == 'True') {
              //successfull updated modal
              const dialogRef = this.dialog.open(UpdateNotificationComponent, {
                data: { message: 'Update Successful ' },
                panelClass: 'app-full-bleed-dialog',

                position: {
                  top: '10%',
                  left: '40.1%',
                },
                backdropClass: 'bdrop',
              });
              dialogRef.afterClosed().subscribe(() => {
                this.isEdit = false;
                this.isEditPassword = false;

                this.global.toggleLoader(true);
                if (this.dashboardService.subscription) {
                  this.dashboardService.subscription.unsubscribe();
                }
                this.dashboardService.subscription = this.dashboardService
                  .getDashboardData()
                  .subscribe((res) => {
                    this.dashboardService.mapsAndProfile = res;

                    // localStorage.setItem(
                    //   'user',
                    //   JSON.stringify(res.profile_payment.profile)
                    // );
                    const encrypted: any = CryptoJS.AES.encrypt(
                      JSON.stringify(res.profile_payment.profile).toString(),
                      this.userEn
                    );
                    localStorage.setItem('user', encrypted);
                    this.dashboardService.setUserInfo(
                      res.profile_payment.profile
                    );
                    this.updateData();
                  });
              });
            } else if (
              res.error.message ==
              'User with this Email Address already exists.'
            ) {
              // email already exist modal
              this.dialog.open(BlankEmailComponent, {
                panelClass: 'app-full-bleed-dialog',
                backdropClass: 'bdrop',
                position: {
                  top: '10%',
                  left: '29.6%',
                },
              });
            }
          },
          () => {
            const dialogRef = this.dialog.open(UpdateNotificationComponent, {
              //update failed modal
              data: { message: 'Update Failed' },
              panelClass: 'app-full-bleed-dialog',
              backdropClass: 'bdrop',
            });
            dialogRef.afterClosed().subscribe(() => {
              this.isEdit = false;
              this.isEditPassword = false;
            });
            this.ngOnInit();
          }
        );
    }
  }

  //for updating password
  changePassword(): void {
    this.passwordMatch = true;
    this.oldPasswordMatch = true;
    this.dashboardService.changePassword(this.passwordForm.value).subscribe(
      (res) => {
        if (res.success == 'true') {
          const dialogRef = this.dialog.open(UpdateNotificationComponent, {
            //password update successfully
            data: { message: 'Update Successful' },
            panelClass: 'app-full-bleed-dialog',
            backdropClass: 'bdrop',
            position: {
              top: '10%',
              left: '40.1%',
            },
          });
          dialogRef.afterClosed().subscribe(() => {
            this.passwordMatch = true;
            this.oldPasswordMatch = true;
            this.isEdit = false;
            this.isEditPassword = false;
            this.global.toggleLoader(true);
            if (this.dashboardService.subscription) {
              this.dashboardService.subscription.unsubscribe();
            }
            this.dashboardService.subscription = this.dashboardService
              .getDashboardData()
              .subscribe((res) => {
                this.dashboardService.mapsAndProfile = res;
                this.ngOnInit();
              });
          });
        } else if (
          res.message == 'Passwords entered do not match, Please try again.'
        ) {
          this.passwordMatch = false;
        } else if (
          res.message ==
          'Current Password or Email is invalid, Please try again.'
        ) {
          this.oldPasswordMatch = false;
        }
      },
      () => {
        //
      }
    );
  }

  editPayment(e: Event): void {
    e.preventDefault();
    this.isEditPayment = true;
  }

  backPayment(e: Event): void {
    e.preventDefault();
    this.isEditPayment = false;
    this.ngOnInit();
  }

  openDialog(): void {
    this.dialog.open(PaymentHistoryComponent);
  }

  //update payment button
  submitPayment(): void {
    setTimeout(() => {
      this.paymentComponent.getToken(this.sendRecurlyToken, this);
    }, 100);
  }
  //getting token for updating profile card info
  sendRecurlyToken(token: any, self = this): void {
    if (!self.auth.user || !token) {
      return;
    } else {
      self.editPay(token);
    }
  }

  //for updating payment card info
  editPay(token: any): void {
    this.dashboardService.editPayment({ recurly_token: token.id }).subscribe(
      (res) => {
        if (res.status == 'true') {
          this.auth.user.type = 'pro';
          // localStorage.setItem('user', JSON.stringify(this.auth.user));
          const encrypted: any = CryptoJS.AES.encrypt(
            JSON.stringify(this.auth.user).toString(),
            this.userEn
          );
          localStorage.setItem('user', encrypted);

          const dialogRef = this.dialog.open(UpdateNotificationComponent, {
            data: { message: 'Update Successful' },
            panelClass: 'app-full-bleed-dialog',
            backdropClass: 'bdrop',
          });
          dialogRef.afterClosed().subscribe(() => {
            this.isEditPayment = false;
          });
          if (this.dashboardService.subscription) {
            this.dashboardService.subscription.unsubscribe();
          }
          this.dashboardService.subscription = this.dashboardService
            .getDashboardData()
            .subscribe((res) => {
              this.dashboardService.mapsAndProfile = res;
              this.ngOnInit();
            });
        } else {
          this.dialog.open(UpdateNotificationComponent, {
            data: { message: 'Update Failed' },
            panelClass: 'app-full-bleed-dialog',
            backdropClass: 'bdrop',
          });
          this.isEditPayment = false;
        }
      },
      () => {
        //
      }
    );
  }
}
